import type { PayloadAction } from '@reduxjs/toolkit';

import type { SettingsBatchTypeLibraryFormMode } from '~/components/feature/settings/batch-type-library/form';

import type { FormSetBatchTypeSubmitDataPayload, FormSetDocumentSubmitDataPayload } from './_reducer.type';
import type { FormState } from './_state.type';

/** Form Reducer. */
export const formReducer = {
  /**
   * Set FormMode.
   *
   * @param {FormState} state State.
   * @param {PayloadAction<SettingsBatchTypeLibraryFormMode | undefined>} action Action.
   */
  form_setMode: (state: FormState, { payload }: PayloadAction<SettingsBatchTypeLibraryFormMode | undefined>) => {
    state.form.mode = payload;
  },

  /**
   * Set BatchType SubmitData.
   *
   * @param {FormState} state State.
   * @param {PayloadAction<FormSetBatchTypeSubmitDataPayload>} action Action.
   */
  form_setBatchTypeSubmitData: (state: FormState, { payload }: PayloadAction<FormSetBatchTypeSubmitDataPayload>) => {
    state.form.batchTypeSubmitData = payload.batchTypeSubmitData;
    state.form.batchTypeTargetDocument = payload.batchTypeTargetDocument;
  },

  /**
   * Set Document SubmitData.
   *
   * @param {FormState} state State.
   * @param {PayloadAction<FormSetDocumentSubmitDataPayload>} action Action.
   */
  form_setDocumentSubmitData: (state: FormState, { payload }: PayloadAction<FormSetDocumentSubmitDataPayload>) => {
    state.form.documentSubmitData = payload;
  },
};
